// extracted by mini-css-extract-plugin
export default {"container":"VerificationCodeInput_container__HQu8d","input":"VerificationCodeInput_input__JNk5A"};